import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function RetentionRate ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const retentionRate = [
    ['Mês', 'Taxa de retenção (%)'],
    ...Object.entries (data).map (([month, values]) => [
      month, Number (values.rate) || 0
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Taxa de retenção (%)</SubTitle>
      <ColumnChart
        data={retentionRate}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          colors: ['#35A7FF'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Taxa (%)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
